export default __webpack_public_path__ + "static/media/thumbsup.b95f9264.png";